var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0086 9.01935L10.7355 0.750502L10.1809 0.195963C10.0546 0.0704453 9.8837 0 9.7056 0C9.5275 0 9.35663 0.0704453 9.23028 0.195963L0.402612 9.01935C0.273143 9.14832 0.170822 9.30191 0.101688 9.47107C0.0325534 9.64023 -0.00199255 9.82152 8.87471e-05 10.0042C0.00865307 10.7579 0.635989 11.3596 1.38965 11.3596H2.29961V18.333H17.1116V11.3596H18.0408C18.4069 11.3596 18.7517 11.2161 19.0107 10.957C19.1383 10.8299 19.2394 10.6787 19.3081 10.5122C19.3768 10.3457 19.4118 10.1672 19.4111 9.98712C19.4111 9.62314 19.2677 9.27842 19.0086 9.01935ZM10.9046 16.7915H8.5066V12.4237H10.9046V16.7915ZM15.57 9.81798V16.7915H12.2749V11.9098C12.2749 11.4366 11.8916 11.0534 11.4185 11.0534H7.99274C7.51956 11.0534 7.13631 11.4366 7.13631 11.9098V16.7915H3.84119V9.81798H1.78575L9.70774 1.9024L10.2023 2.39699L17.6276 9.81798H15.57Z",
    fill: "#A0A3B1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.14d53a66f29c522c13dbbc1672abe4fc.svg";
export { ForwardRef as ReactComponent };